<template>
	<div>
		<div class="row" >
			<div class="col-12" v-if="travaContinuar == 1">
				<div class="card mb-2">
					<div class="card-body pb-0">
						<div class="row" >
							<div class="col-12 mb-3">
								<label><i class="far fa-user font-13 color-theme mr-1"></i><span class="font-14"> Nome completo: </span></label>
								<input type="text" class="form-control required rounded" maxlength="200"  placeholder="Nome do usuário" v-model="user.nome"/>  
							</div>
							<div class="col-12 mb-3">
								<label><i class="far fa-envelope font-13 color-theme mr-1"></i><span class="font-14"> Email: </span></label>
								<input type="email" class="form-control required rounded" maxlength="200"  placeholder="Email do usuário" v-model="user.email"/>  
							</div>
							<div class="col-12 mb-3">
								<label><i class="fas fa-key font-13 color-theme mr-1"></i><span class="font-14"> Senha: </span></label>
								<input type="text" class="form-control required rounded" maxlength="200"  placeholder="Senha do usuário" v-model="user.senha"/>  
							</div>
							<div class="col-12 mb-3">
								<div class="d-flex justify-content-between ">
									<span class="font-14"> Esse usuario terá acesso admin: </span>
									<label class="container_marker">
										<input type="checkbox" v-model="user.admin">
										<div class="checkmark"></div>
									</label>
								</div>
							</div>
                            <div class="col-12">
								<button type="button" class="btn btn-secondary w-100 mt-2 mb-3 rounded" @click="continuar()">
									<i class="fas fa-long-arrow-right mr-1"></i><span class="font-14 font-weight-bold">Continuar</span>
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>

            <div class="col-12" v-else-if="travaContinuar == 2">
                <div class="card mb-2">
                    <div class="d-flex text-center justify-content-center mt-3 mb-2">
                        <h3 class="">Escolas vinculadas ao login do usuário</h3>
                    </div>
                    <div class="col-12">
                        <div class="row">
                            <div class="col-10 mb-3">
                                <input type="text" class="form-control rounded" v-model="valor" maxlength="200"
                                placeholder="Pesquisa por escola" />
                            </div>
                            <div class="col-2 mb-3">
                                <button class=" btn btn-secondary w-100 rounded" @click="getEscola()">
                                    <i class="fa fa-search font-13"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="row">
                            <div class="col-6 mb-3">
                                <button class=" btn btn-secondary w-100 rounded" @click="voltar()">
                                    <i class="fas fa-long-arrow-left mr-1"></i><span class="font-14 font-weight-bold">Voltar</span>
                                </button>
                            </div>
                            <div class="col-6 mb-3">
                                <button class=" btn btn-secondary w-100 rounded" @click="salvar()">
                                    <i class="fa fa-save font-13 mr-1"></i><span class="font-14 font-weight-bold">Salvar</span>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex justify-content-center mb-1 font-italic font-14">
                        <span v-if="user.listaEscola.length == 1">{{user.listaEscola.length + ' resultado encontrado'}}</span>
                        <span v-else-if="user.listaEscola.length > 1">{{user.listaEscola.length + ' resultados encontrados'}}</span>
                    </div>
                </div>
				<div class="cards-3 mb-0 mt-0">
                    <div v-for="(escola, index) in user.listaEscola" :key="index" :index="index" class="">
                        <div class="card mb-2">
                            <div class="d-flex justify-content-between">
                                <div class=" cursor-pointer p-3 font-16 align-self-center">
                                    <span class="limitador font-18 unicoLimitador">{{escola.nome}}</span>
                                    <span class="limitador font-italic unicoLimitador">{{escola.endereco}}</span>
                                </div>
                                <div class="mr-4 align-self-center">
                                    <label class="container_marker">
                                        <input type="checkbox" v-model="escola.addEscola">
                                        <div class="checkmark"></div>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
            </div>
		</div>
	</div>
</template>

<script>

import { mapState } from 'vuex'

export default {
	name: 'GerarLogin',
	computed: {
		... mapState({
			dadosUsuario: state => state.dadosUsuario,
			isCarregando: state => state.isCarregando,
			isLogado: state => state.isLogado,
			urlRest: state => state.urlRest
		})
	},
	data() {
        return {
            travaContinuar: 1,
            user: {
                nome: '',
                email: '',
                senha: '',
                admin: false,
                listaEscola: [
                    {'addEscola': false}
                ],
            },
            valor: ''
        };
    },
	methods: {
		salvar() {
            let ref = this;
            this.$axios({
                method: 'post',
                url: this.urlRest +'service/addUser',
                headers: {
                    'Content-Type': 'application/json'
                },

                data: this.user
            }).then(function () {
                ref.$toast.fire({
                    icon: 'success',
                    title: 'Usuário salvo!',
                    timer: 1000
                })
                ref.limparInputs()
            }).catch(function (error) {
                if (error.response != undefined) {
                    if (error.response.status == 408) {
                        ref.$store.dispatch('deslogar')

                        ref.$toast.fire({
                            icon: 'warning',
                            title: 'Sessão expirada!'
                        });
                    } else {
                        ref.$toast.fire({
                            icon: 'error',
                            title: 'Erro: ' + error.response.status
                        })
                    }
                    } else {
                        ref.$toast.fire({
                            icon: 'error',
                            title: error
                        })
                    }
                }).finally(() => {
                    this.$store.dispatch('alternarTelaCarregamento', false);
                });
                this.user 
        },
		getEscola() {
            let ref = this;
            this.$axios({
                method: 'get',
                url: this.urlRest +'service/getEscola',
				params: {
					valor: this.valor
				},
                headers: {
                    'Content-Type': 'application/json'
                },

            }).then(response => {
				ref.user.listaEscola = response.data;

			}).catch(function (error) {
                if (error.response != undefined) {
                    if (error.response.status == 408) {
                        ref.$store.dispatch('deslogar')

                        ref.$toast.fire({
                            icon: 'warning',
                            title: 'Sessão expirada!'
                        });
                    } else {
                        ref.$toast.fire({
                            icon: 'error',
                            title: 'Erro: ' + error.response.status
                        })
                    }
                    } else {
                        ref.$toast.fire({
                            icon: 'error',
                            title: error
                        })
                    }
                }).finally(() => {
                    this.$store.dispatch('alternarTelaCarregamento', false);
                });
                this.user 
        },
		limparInputs() {
			this.user.nome = ''
			this.user.email = ''
			this.user.senha = ''
			this.user.admin = false
            this.travaContinuar = 1
		},
        continuar() {
            this.travaContinuar = this.travaContinuar + 1
        },
        voltar() {
            this.travaContinuar = this.travaContinuar - 1
        },
	},
	watch: {
		isLogado : function(value) {
			if (value) {
				require("@/assets/vendor/bootstrap/js/bootstrap.bundle.js")
			}
		}
	},
	components: {
		
	},
	mounted(){
		// this.$store.dispatch('verificarCredenciais')
		this.getEscola()
   }
}

</script>

<style scoped>
    .remove-bold {
        font-weight: normal !important;
    }

	.container_marker input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}


.container_marker {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  cursor: pointer;
  font-size: 20px;
  user-select: none;
  border-radius: 50%;
  background-color: rgb(78, 78, 78);
}

/* Create a custom checkbox */
.checkmark {
  position: relative;
  top: 0;
  left: 0;
  height: 1em;
  width: 1em;
  transition: .3s;
  transform: scale(0);
  border-radius: 50%;
}

/* When the checkbox is checked, add a blue background */
.container_marker input:checked ~ .checkmark {
  background-color: #2096c5;
  transform: scale(1);
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.container_marker input:checked ~ .checkmark:after {
  display: block;
}

.container_marker input:checked ~ .celebrate {
  display: block;
}

/* Style the checkmark/indicator */
.container_marker .checkmark:after {
  left: 7px;
  top: 0.25em;
  width: 0.30em;
  height: 0.5em;
  border: solid rgb(255, 255, 255);
  border-width: 0 0.15em 0.15em 0;
  transform: rotate(45deg);
}

.container_marker .celebrate {
  position: absolute;
  transform-origin: center;
  animation: kfr-celebrate .4s;
  animation-fill-mode: forwards;
  display: none;
  stroke: #0392CF;
}

@keyframes kfr-celebrate {
  0% {
    transform: scale(0);
  }

  50% {
    opacity: 1;
  }

  100% {
    transform: scale(1.2);
    opacity: 0;
    display: none;
  }
}
</style>